module.exports = __webpack_public_path__ + "media/src/images/icons/flags/mexico-e94226f8876487ea17b429dc1789c0b9.svg";